import { render } from "./app-tabs.vue?vue&type=template&id=fe05e846&scoped=true"
import script from "./app-tabs.vue?vue&type=script&lang=js"
export * from "./app-tabs.vue?vue&type=script&lang=js"

import "./app-tabs.vue?vue&type=style&index=0&id=fe05e846&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe05e846"]])

export default __exports__